import React from 'react';
interface KpiCardProps {
  title: string;
  value: string;
  change?: {
    value: string;
    positive: boolean;
  };
  icon?: React.ReactNode;
  color?: 'purple' | 'blue' | 'pink' | 'orange' | 'green';
}
export function KpiCard({
  title,
  value,
  change,
  icon,
  color = 'purple'
}: KpiCardProps) {
  const colorStyles = {
    purple: 'bg-[#7B68EE]/10 text-[#7B68EE]',
    blue: 'bg-[#1DA1F2]/10 text-[#1DA1F2]',
    pink: 'bg-[#FF6B81]/10 text-[#FF6B81]',
    orange: 'bg-[#FFB84D]/10 text-[#FFB84D]',
    green: 'bg-[#00C853]/10 text-[#00C853]'
  };
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 h-full transition-all hover:shadow-md" data-id="element-594">
      <div className="flex items-start" data-id="element-595">
        {icon && <div className={`flex-shrink-0 p-3 rounded-lg ${colorStyles[color]}`} data-id="element-596">
            {icon}
          </div>}
        <div className={icon ? 'ml-4' : ''} data-id="element-597">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-598">{title}</h3>
          <div className="mt-1 flex items-baseline" data-id="element-599">
            <p className="text-2xl font-semibold text-gray-900" data-id="element-600">{value}</p>
            {change && <p className={`ml-2 text-sm font-medium ${change.positive ? 'text-[#00C853]' : 'text-[#FF6B81]'}`} data-id="element-601">
                {change.positive ? '+' : ''}
                {change.value}
              </p>}
          </div>
        </div>
      </div>
    </div>;
}